const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
  'Eighteen', 'Nineteen']
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety']

function convertHundreds(n: number): string {
  if (n === 0) return ''
  if (n < 20) return ONES[n]
  if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? ' ' + ONES[n % 10] : '')
  return ONES[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + convertHundreds(n % 100) : '')
}

// Converts a rupee amount (positive integer or decimal) to Indian words
// e.g. 100500.50 → "One Lakh Five Hundred Rupees and Fifty Paise Only"
export function amountToWords(rupees: number): string {
  if (!isFinite(rupees) || rupees < 0) return ''
  const [rupeeStr, paiseStr = '00'] = rupees.toFixed(2).split('.')
  const rupeeInt = parseInt(rupeeStr, 10)
  const paiseInt = parseInt(paiseStr.padEnd(2, '0').slice(0, 2), 10)

  if (rupeeInt === 0 && paiseInt === 0) return 'Zero Rupees Only'

  const crore = Math.floor(rupeeInt / 10_000_000)
  const lakh = Math.floor((rupeeInt % 10_000_000) / 100_000)
  const thousand = Math.floor((rupeeInt % 100_000) / 1_000)
  const remainder = rupeeInt % 1_000

  const parts: string[] = []
  if (crore) parts.push(convertHundreds(crore) + ' Crore')
  if (lakh) parts.push(convertHundreds(lakh) + ' Lakh')
  if (thousand) parts.push(convertHundreds(thousand) + ' Thousand')
  if (remainder) parts.push(convertHundreds(remainder))

  let result = parts.join(' ') + ' Rupees'
  if (paiseInt) result += ' and ' + convertHundreds(paiseInt) + ' Paise'
  return result + ' Only'
}
